import { useAxiosModule } from '@/modules/_shared/axios'
import * as types from './types'
import { InvoiceSearchFilter } from '@/views/_shared/search-list/types'

const {
    getFromApi,
    postToApi,
    deleteInApi
} = useAxiosModule()

export type GetInvoicesListResponse = types.GetInvoicesList

export const getInvoices = async (search = {} as InvoiceSearchFilter, orderBy = 'id desc', limit = 0, offset = 0) => {
    const queryParams = new URLSearchParams()
    queryParams.set('status', search.status)
    queryParams.set('resourceName', search.agreementName)
    queryParams.set('search', search.search)
    queryParams.set('organizationId', search.organization)
    queryParams.set('from', search.dateFrom)
    queryParams.set('to', search.dateTo)
    queryParams.set('sort', orderBy)
    queryParams.set('limit', String(limit))
    queryParams.set('offset', String(offset))
    const getFilteredInvoicesUrl = 'invoices?' + queryParams.toString()
    return getFromApi<GetInvoicesListResponse>(getFilteredInvoicesUrl)
}

export type GetInvoiceResponse = types.Invoice
export const getInvoice = async (invoiceId: string) =>
    getFromApi<GetInvoiceResponse>(`invoices/${invoiceId}`)

export type InvoicePreviewRequest = types.InvoicePreviewPayload
export type GetInvoicePreviewResponse = types.Invoice
export const getInvoicePreview = async (payload: InvoicePreviewRequest) =>
    postToApi<GetInvoicePreviewResponse>('invoices/preview', payload)

export type GetInvoicingExternalLogsResponse = types.InvoicingExternalLogs
export const getInvoicExternalLogs = async (invoiceId: string) =>
    getFromApi<GetInvoicingExternalLogsResponse>(`invoices/external-log/${invoiceId}`)

export type CreateInvoicePayload = types.CreateInvoice

export const revokeInvoice = async (invoiceId: string) =>
    deleteInApi<null>('invoices/', { invoiceId: invoiceId })

export const createAllInvoices = async (issueDate: string, operatorId:string) => {
    postToApi<null>('invoices/create-all', { issueDate, operatorId })
}

export type CreateInvoiceForAgreementPayload = types.CreateInvoiceForAgreement
export const createInvoiceForAgreement = async (payload: CreateInvoiceForAgreementPayload) => {
    await postToApi<null>('invoices/', payload)
}
